export default __webpack_public_path__ + "static/media/Waves.ae6b6624.wav";